module.exports = __webpack_public_path__ + "img/banner-4.c4ec1a0a.jpg";